module.exports = __webpack_public_path__ + "static/media/garbage_truck_icon.c8313897.svg";